import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY } from '../../theme/onboardingTheme'

export function StepApplications() {
  const { state, dispatch } = useOnboarding()

  return (
    <Stack spacing={4}>
      <Paper
        variant="outlined"
        sx={{
          borderColor: '#e2e8f0',
          borderRadius: '12px',
          backgroundColor: 'rgba(255, 251, 235, 0.6)',
          p: 2,
          fontSize: 14,
          color: '#451a03',
        }}
      >
        <Typography sx={{ fontWeight: 600 }}>Branch licensing</Typography>
        <Typography sx={{ mt: 0.5, fontSize: 12, color: 'rgba(120, 53, 15, 0.9)' }}>
          If any producers operate under a branch, additional forms may be required.
        </Typography>
        <Stack direction="row" flexWrap="wrap" spacing={1} sx={{ mt: 1.5 }}>
          <Button
            type="button"
            onClick={() => dispatch({ type: 'SET_BRANCH', value: true })}
            sx={{
              borderRadius: '8px',
              px: 1.5,
              py: 0.75,
              fontSize: 12,
              fontWeight: 600,
              ...(state.branchUnderBranch === true
                ? { backgroundColor: '#b45309', color: '#ffffff', '&:hover': { backgroundColor: '#b45309' } }
                : {
                    backgroundColor: '#ffffff',
                    color: '#78350f',
                    boxShadow: 'inset 0 0 0 1px #fcd34d',
                    '&:hover': { backgroundColor: '#ffffff' },
                  }),
            }}
          >
            Yes
          </Button>
          <Button
            type="button"
            onClick={() => dispatch({ type: 'SET_BRANCH', value: false })}
            sx={{
              borderRadius: '8px',
              px: 1.5,
              py: 0.75,
              fontSize: 12,
              fontWeight: 600,
              ...(state.branchUnderBranch === false
                ? { backgroundColor: '#b45309', color: '#ffffff', '&:hover': { backgroundColor: '#b45309' } }
                : {
                    backgroundColor: '#ffffff',
                    color: '#78350f',
                    boxShadow: 'inset 0 0 0 1px #fcd34d',
                    '&:hover': { backgroundColor: '#ffffff' },
                  }),
            }}
          >
            No
          </Button>
        </Stack>
        {state.branchUnderBranch === true ? (
          <Typography sx={{ mt: 1, fontSize: 12, color: '#78350f' }}>
            Branch form placeholder — would collect branch details (demo only).
          </Typography>
        ) : null}
      </Paper>

      <Stack spacing={1.5}>
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>
          Producer applications (NAIC)
        </Typography>
        {state.producers.map((p) => (
          <Paper
            key={p.npn}
            variant="outlined"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { sm: 'center' },
              justifyContent: { sm: 'space-between' },
              gap: 1.5,
              borderColor: '#e2e8f0',
              borderRadius: '12px',
              backgroundColor: '#ffffff',
              p: 2,
              boxShadow: 1,
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 500, color: '#0f172a' }}>{p.name}</Typography>
              <Typography sx={{ fontSize: 12, color: '#64748b' }}>NPN {p.npn}</Typography>
              <Typography sx={{ mt: 0.5, fontSize: 12, textTransform: 'capitalize', color: '#475569' }}>
                Status: {p.appStatus.replace('_', ' ')}
              </Typography>
            </Box>
            <Stack direction="row" flexWrap="wrap" spacing={1}>
              <Button
                type="button"
                variant="outlined"
                onClick={() =>
                  dispatch({
                    type: 'UPDATE_PRODUCER',
                    npn: p.npn,
                    patch: { appStatus: 'generated' },
                  })
                }
                sx={{
                  borderColor: '#e2e8f0',
                  px: 1.5,
                  py: 0.75,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#0f172a',
                  '&:hover': { backgroundColor: '#f8fafc' },
                }}
              >
                Generate application
              </Button>
              <Button
                type="button"
                variant="outlined"
                onClick={() =>
                  dispatch({ type: 'UPDATE_PRODUCER', npn: p.npn, patch: { appStatus: 'sent' } })
                }
                sx={{
                  borderColor: 'rgba(37, 99, 235, 0.4)',
                  px: 1.5,
                  py: 0.75,
                  fontSize: 12,
                  fontWeight: 600,
                  color: MISC_PRIMARY,
                  '&:hover': { backgroundColor: '#eff6ff' },
                }}
              >
                Send DocuSign (mock)
              </Button>
              <Button
                type="button"
                variant="contained"
                onClick={() =>
                  dispatch({ type: 'UPDATE_PRODUCER', npn: p.npn, patch: { appStatus: 'signed' } })
                }
                sx={{
                  backgroundColor: '#0f172a',
                  px: 1.5,
                  py: 0.75,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#ffffff',
                  '&:hover': { backgroundColor: '#1e293b' },
                }}
              >
                Mark signed (demo)
              </Button>
            </Stack>
          </Paper>
        ))}
      </Stack>
    </Stack>
  )
}
